// =============================================
// File: src/services/addressService.js
// =============================================

import axiosInstance from "./axiosConfig";

const addressService = {
  // Get all addresses for logged-in user
  getAddresses: async () => {
    try {
      const response = await axiosInstance.get("/address");
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get single address by ID
  getAddressById: async (id) => {
    try {
      const response = await axiosInstance.get(`/address/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get default address
  getDefaultAddress: async () => {
    try {
      const response = await axiosInstance.get("/address/default");
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Create new address
  createAddress: async (addressData) => {
    try {
      const response = await axiosInstance.post("/address", addressData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update address
  updateAddress: async (id, addressData) => {
    try {
      const response = await axiosInstance.put(`/address/${id}`, addressData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Delete address
  deleteAddress: async (id) => {
    try {
      const response = await axiosInstance.delete(`/address/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Set address as default
  setDefaultAddress: async (id) => {
    try {
      const response = await axiosInstance.patch(`/address/${id}/set-default`);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default addressService;
